import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import {jwtDecode} from 'jwt-decode';
import { ConfigService } from './config.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  token = "";
 
  constructor(private msalservice: MsalService, private config:ConfigService) { }


  getToken() {
    let length = localStorage.length;
    for (var i = 0; i < length; i++) {

      var tokenKey = localStorage.key(i) || '{}'
      if (tokenKey.search("scopes") > 0) 
      {
        var itemValue = localStorage.getItem(tokenKey) || '{}'
        var at = JSON.parse(itemValue); 
        this.token = at.accessToken;
        return this.token
      }
    
    }

  }


  setAccessToken(accessToken:string){
    this.token=accessToken;
  }

  getAccessToken(){
  return this.token;
  }
  getDelegatedToken(){
    let account = this.msalservice.instance.getAllAccounts();
    // let appId = config.getSettings('config').auth.delegatedClientID
    return this.msalservice.acquireTokenSilent({
        account: account[0],
        //scopes: ['api://57ec4097-4ba6-42be-b786-41250fad45ee/Data.FullRead']
        scopes: [this.config.getSettings('config').auth.clientId + '/.default']
        //  scopes: ["feacf2e9-234e-4eef-85fe-534b0551bdd3/.default"]
    }).pipe(map(res => {
        this.token = res.accessToken;
        return res.accessToken;
    }));
}

  getAccountDetail() {
    if(!this.token){
      this.getToken();
    }
    let jwtData: any = jwtDecode(this.token);
    console.log("jwt: "+JSON.stringify(jwtData));
    let empNumber = jwtData["EmpNo"];
    let empName = jwtData["name"];
    // let emailID = jwtData["unique_name"];
    let emailID = jwtData["upn"];


    return { 'empNo': empNumber, 'empName': empName, 'emailId': emailID };
  }
}
